import { Component } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { environment } from '@environments/environment';

import {
  PatientService,
  AppointmentService,
  LocationService,
} from './_services';

declare var $: any;

@Component({ selector: 'app', templateUrl: 'app.component.html' })
export class AppComponent {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  title = 'angular-idle-timeout';
  patient: any;
  idle_sec = environment.session_idle;
  sess_timeout = environment.session_timeout;
  isLoggedin = false;
  orders_module=false;
  currentRoute: string = '';
  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private patientService: PatientService,
    private apptService: AppointmentService,
    private locationService: LocationService,
    private router: Router
  ) {
    this.patientService.patient$.subscribe((x) => {
      this.patient = x;
      if (
        this.patient === null ||
        typeof this.patient.token.status == 'undefined' ||
        this.patient.token.status == false
      )
        this.isLoggedin = false;
      else if (
        typeof this.patient.token.status != 'undefined' ||
        this.patient.token.status == true
      )
        this.isLoggedin = true;
        // console.log(this.patient);
    });
    this.sessionHandling();
     this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
      }
    });
  }

  sessionHandling() {
    this.idle.setIdle(environment.session_idle);
    this.idle.setTimeout(environment.session_timeout);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      this.reset();
    });

    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.patientService.logout();
      this.apptService.setAppointmentInfo(null);
      $('#sesModal').modal('hide');
      this.router.navigate(['/account/login']);
    });

    this.idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
      $('#sesModal').modal('show');
      // this.childModal.show();
    });
    this.idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
      this.sess_timeout = countdown;
    });
    this.keepalive.interval(15);

    this.keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
    $('#sesModal').modal('hide');
  }

  logout() {
    if (confirm('Are you sure want to logout ? ')) {
      this.patientService.logout();
      this.apptService.setAppointmentInfo(null);
    }
  }

  gotoProfile() {
    console.log(this.patient);
    if (
      this.patient != null &&
      typeof this.patient.info.info.data[0].UHID != 'undefined'
    )
      this.router.navigate([
        '/profile/info',
        this.patient.info.info.data[0].UHID,
      ]);
  }
  gotoPatient(patient) {
    // console.log(patient);
    // return false;
    let pid = '';
    if (patient != null && typeof patient.pid != 'undefined') pid = patient.pid;
    else if (patient != null && typeof patient.temporary_id != 'undefined')
      pid = patient.temporary_id;
    this.router.navigate(['/profile/info', pid]);
  }

   isAdminRoute(): boolean {
    return this.currentRoute.startsWith('/portal-admin');
  }
}
